import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.99956 2.00161V1H6.99956V5H5.99956V7H6.99956V10C6.99956 10.9409 6.92504 11.9629 6.80443 13H4.99956V15H6.52248C6.37099 15.9278 6.19689 16.8335 6.02101 17.669C5.77454 18.8397 5.52796 19.8569 5.34314 20.5807C5.25078 20.9425 5.17398 21.2304 5.12052 21.4271C5.01865 21.8019 4.91111 22.1751 4.80359 22.5483C4.76021 22.6988 4.71683 22.8494 4.67383 23H10.2803L11.2803 19H12.7188L13.7188 23H19.3253C19.2823 22.8494 19.2389 22.6988 19.1955 22.5482C19.088 22.1751 18.9805 21.8018 18.8786 21.4271C18.8251 21.2304 18.7483 20.9425 18.656 20.5807C18.4712 19.8569 18.2246 18.8397 17.9781 17.669C17.8022 16.8335 17.6281 15.9278 17.4766 15H18.9996V13H17.1947C17.0741 11.9629 16.9996 10.9409 16.9996 10V7H17.9996V5H16.9996V1H14.9996V2.00161H8.99956ZM8.99956 5V4.00161H14.9996V5H8.99956ZM13.0039 8.99805V11.002H11V8.99805H13.0039Z"}}]};

const Lighthouse2Filled = Vue.extend<IconProps>({
  name: 'Lighthouse2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'lighthouse-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Lighthouse2Filled;
